export default "__VITE_ASSET__64ko4Jbx__"